module.exports = "https://trybtryb-legacy.web.app/img/soundcloud.b9d5cd56.svg";